import IPixelMapDay from "@interfaces/pixel-map-day.interface";

const julyMap: Array<IPixelMapDay> = [
	{
		status: "good",
		reason: "I had fun playing the new Spider-Man game today, I finished around 1/3 of the campaign already.",
		spotify: {
			artist: "​kyary pamyu pamyu",
			album: "ぱみゅぱみゅレボリューション",
			song: "つけまつける",
			link: "https://open.spotify.com/track/3ou1fnaevjh2rj6gSNLTim?si=13670b7b3a824d2d"
		}
	},
	{
		status: "above-average",
		reason: "I played The Forest. I also went out and gave those keyboard switches.",
		spotify: {
			artist: "aespa",
			album: "MY WORLD - The 3rd Mini Album",
			song: "Salty & Sweet",
			link: "https://open.spotify.com/track/4wQDjZtXjsFtU3BLSiIH4t?si=031e97c5b49d4ae5"
		}
	},
	{
		status: "above-average",
		reason: "I started watching Derry Girls on Netflix today and played Phasmophobia with a friend. We got hunted by the ghost and it was kinda scary. In the evening, I met someone new and my guy best friend (finally) reached out to me after months. I was kind of disappointed with myself when I updated him about how things have been. I wish things were better, but I'm happy enough as-is.",
		spotify: {
			artist: "Taylor Swift",
			song: "Everything Has Changed (feat. Ed Sheeran) (Taylor’s Version)",
			link: "https://open.spotify.com/track/7qEUFOVcxRI19tbT68JcYK?si=4f78b24f70c14869",
			album: "Red (Taylor's Version)"
		}
	},
	{
		status: "excellent",
		reason: "Surprisingly, I felt very productive today at work because I got a lot of tasks done. I also played The Forest and had a fun round of Phasmo again. I also watched Derry Girls and other stuff. I operated on very little sleep today, but I somehow managed to get through things. I got to talk to a lot of my friends today as well, and got to send a few fun emails. Today was actually an excellent day, surprisingly.",
		spotify: {
			artist: "BTS, Jason Derulo, Jawsh 685",
			song: "Savage Love (Laxed - Siren Beat) [BTS Remix]",
			link: "https://open.spotify.com/track/4TgxFMOn5yoESW6zCidCXL?si=0e59686d86d54ba1",
			album: "Savage Love (Laxed - Siren Beat) [BTS Remix]"
		}
	},
	{
		status: "bad",
		title: "Keeping Tally",
		reason: "The day actually went on as average. It's the evening that hit me. I don't know why I'm keeping tally and I thought I was right. I had to handle myself going through a quick breakdown. I calmed myself down enough to consider that I may have been in the wrong. I was able to steer myself out of it, but damn, I should take care of my mental health better.",
		spotify: {
			artist: "BLACKPINK",
			album: "BORN PINK",
			song: "Tally",
			link: "https://open.spotify.com/track/6Ho58vQUjGnBU9m8Z6uNcv?si=7515421dc54e4f3a"
		}
	},
	{
		status: "above-average",
		reason: "I really did make a mistake last night about overthinking about the wrong things. I apologized and things returned to their usual state. The status quo, the usual. I had fun today, regardless. and played The Forest.",
		spotify: {
			artist: "DJ Fresh",
			song: "The Power (feat. Dizzee Rascal) - Radio Edit",
			link: "https://open.spotify.com/track/6nq8E2aA2xCwGNE36VMiF7?si=52de9226ec9e425b",
			album: "Nextlevelism"
		}
	},
	{
		status: "good",
		title: "And They Said, \"Speak Now\"",
		icon: "library_music",
		reason: "Taylor Swift released her new version of Speak Now today!!!! I'm actually so happy! This is my favorite album from hers and this day was just really good. I tried to book a ticket to their concert in Singapore, but I unfortunately got a late spot in the queue to buy a ticket. I had so much fun today trying to book a ticket with my friends, talking to friends about Taylor Swift, playing The Forest with my friends and migrating to a new base.",
		spotify: {
			artist: "Taylor Swift",
			song: "The Story Of Us (Taylor's Version)",
			link: "https://open.spotify.com/track/6dTA6y0C2ReQklntzZl8l3?si=d8ea718d75494fbf",
			album: "Speak Now (Taylor's Version)"
		}
	},
	{
		status: "average",
		title: "I've Been...",
		reason: `Today wasn't really anything of note. I was able to open up about how I'm actually doing, and it was an \"okay\" experience. I got to return my controller today and fix that issue with my Macbook. In the evening, I was able to ponder about my current experience, that I'm falling, and I found the perfect song for this chapter of my life.`,
		spotify: {
			artist: "Jacob Collier",
			album: "Djesse Vol. 3",
			song: "Sleeping On My Dreams",
			link: "https://open.spotify.com/track/4mTd21pyWajN252LcouVIm?si=66b182b42403440a"
		},
		resonatedLyrics: [
			"'Cause I've been sleeping on my dreams, ah",
			"And I can't remember what I mean to you"
		],
	},
	{
		status: "below-average",
		reason: `I wasn't feeling okay for most of the day. I met more temporary people and I knew it wouldn't last. I was already feeling unwell, but the evening turned things around.`,
		spotify: {
			artist: "Jonathan Groff",
			album: "Hamilton (Original Broadway Cast Recording)",
			song: "You'll Be Back",
			link: "https://open.spotify.com/track/6OG1S805gIrH5nAQbEOPY3?si=fc873a115b0641ae"
		},
		resonatedLyrics: [
			"Oceans rise, empires fall",
			"We have seen each other through it all"
		],
	},
	{
		status: "good",
		reason: `Monday isn't that hard and the start of the week was good, all things considered. So I'm counting this as a good day. I got to watch Derry Girls again.`,
		spotify: {
			artist: "NewJeans",
			album: "NewJeans 'Super Shy'",
			song: "Super Shy",
			link: "https://open.spotify.com/track/5sdQOyqq2IDhvmx2lHOpwd?si=11e609883f27412a"
		},
	},
	{
		status: "above-average",
		reason: "I'm surprised I did a lot of tasks and things today, all in the span of a day. I'm surprised.",
		spotify: {
			artist: "Taylor Swift",
			song: "I Can See You (Taylor's Version) (From The Vault)",
			link: "https://open.spotify.com/track/5kHMfzgLZP95O9NBy0ku4v?si=e790e5d1f4284191",
			album: "Speak Now (Taylor's Version)"
		}
	},
	{
		status: "above-average",
		reason: "I organized stuff for Sportstival next month.",
		spotify: {
			artist: "Little Mix",
			song: "Black Magic",
			link: "https://open.spotify.com/track/6rmXhRIemCTPyMYZRDN7Qg?si=90f43d8c050944c6",
			album: "Get Weird (Expanded Edition)"
		}
	},
	{
		status: "above-average",
		reason: "I had a busy day at work. I feel pressured to have to take on so many new things at once and I have to burn off time in the evenings just to learn new things. But we got to play The Forest as work was ending and then I passed out.",
		spotify: {
			artist: "Taylor Swift",
			song: "Superman (Taylor's Version)",
			link: "https://open.spotify.com/track/4evLyY5Ue1Wesc61t2KXAU?si=939e6b006b694d27",
			album: "Speak Now (Taylor's Version)"
		}
	},
	{
		status: "below-average",
		reason: "I also had to give my friends that gift I've been preparing.",
	},
	{
		status: "above-average",
		title: "That Was Close",
		reason: "They like the gift! I also got that massage today.",
		spotify: {
			artist: "K'NAAN",
			song: "Wavin' Flag (Celebration Mix)",
			link: "https://open.spotify.com/track/6MPzzCxr4lKFzT35c1hXNH?si=d1242dcf2e104955",
			album: "Wavin' Flag (Celebration Mix)"
		},
		resonatedLyrics: [
			"When I get older I will be stronger",
			"They'll call me freedom just like a wavin' flag"
		],
	},
	{
		status: "below-average",
		title: "And Take A Shot of Hennessy",
		reason: "I spent most of the day alone, surprisingly. Just doing my free time stuff. The bulk of my day was just spent on watching YouTube, but hey, I found some pretty cool songs.",
		spotify: {
			artist: "AJR",
			song: "World's Smallest Violin",
			link: "https://open.spotify.com/track/68EkhVWIeULhHxcbi1QhzK?si=5eb0f610eb354e4f",
			album: "OK ORCHESTRA"
		},
		resonatedLyrics: [
			"Like finishing this melody",
			"This feels like a necessity",
			"",
			"So this could be the death of me",
			"Or maybe just a better me",
			"",
			"Now, come in with the timpanis",
			"And take a shot of Hennessy",
			"I know I'm not there mentally",
			"But you could be the remedy",
			"So let me play my violin for you"
		],
	},
	{
		status: "below-average",
		reason: "I guess I really am holding on tight, and the song I subconsciously played the most today reflected that.",
		spotify: {
			artist: "aespa",
			song: "Hold On Tight",
			link: "https://open.spotify.com/track/1o844wI52S3TjXGBwvGcc7?si=ad1b4d8c51284fbd",
			album: "Hold On Tight"
		},
		resonatedLyrics: [
			"Baby, you and me are a twisted fantasy",
			"Bodies running on a dream, up all night",
			"",
			"Wired differently, a chaotic energy",
			"Buckle up and take a seat, hold on tight",
		],
	},
	{
		status: "above-average",
		title: "Mac Time",
		icon: "laptop_mac",
		reason: "I'm going to use my Mac as my main computer for a week. I've had this MacBook for a long time but never really used it that much at home because I have my own PC. I only use this when I'm outside, or at a Starbucks. Setting it up was such a pain, but I had a good day. I had a lot of things to be happy about.",
		spotify: {
			artist: "TWICE",
			song: "Heart Shaker",
			link: "https://open.spotify.com/track/52FCAZn0YEkZfF0BtiAUMW?si=2de051b592414419",
			album: "Merry & Happy"
		},
	},
	{
		status: "good",
		title: "moving on like it's a corny Y2K movie",
		icon: "emoji_people",
		reason: "I updated one of my corny playlists, aptly titled, \"moving on like it's a corny Y2K movie\" and found a lot of fun songs for it. Now, I'm not moving on or anything, but this is definitely one of the playlists to play on a good day or something. I also felt like I did a lot of work today, despite feeling a bit limited with the Mac. I also got to talk to a lot of friends today, so that's nice.",
		spotify: {
			artist: "The Beatles",
			song: "Twist And Shout",
			link: "https://open.spotify.com/track/5ZBeML7Lf3FMEVviTyvi8l?si=3654e356bc224287",
			album: "Please Please Please Me"
		},
		resonatedLyrics: [
			"Well, shake it up, baby, now (Shake it up, baby)",
			"Twist and shout (Twist and shout)",
			"C'mon, c'mon, c'mon, c'mon, baby, now (Come on, baby)",
			"Come on and work it on out (Work it on out)",
		],
	},
	{
		status: "above-average",
		icon: "verified",
		reason: "I decided to get verified on IG today lol. I dunno why I decided to, but it is what it is. I decided to watch the Barbie movie. It was a good day.",
		spotify: {
			artist: "aespa",
			album: "MY WORLD - The 3rd Mini Album",
			song: "Spicy",
			link: "https://open.spotify.com/track/1ULdASrNy5rurl1TZfFaMP?si=d25d8922b1bd4b9c"
		},
		resonatedLyrics: [
			"You want my A to the Z, but you won't, 어림없지",
			"맞혀봐 sweet, 또는 freak, what's hiding underneath? (I see)",
		],
	},
	{
		status: "special",
		icon: "sleep_score",
		title: "0% Sleep, 100% Fun",
		reason: "My company organized a 'work together' thing today and I got to be in a shared co-working space with my friends from work! It was a really, really fun day with my coworkers once again. I am so sleepy for today, I stayed up until 4 a.m. in the morning I was lacking sleep all day. But in the end, I was able to get to meet my other coworkers, befriend them, play Phasmophobia for hours with them, and NewJeans finally released their album today. Today was really fun. I haven't felt this relieved and at ease in a long time. It feels surreal and the song I liked for today reflects that.",
		spotify: {
			artist: "NewJeans",
			album: "NewJeans 2nd EP 'Get Up'",
			song: "Cool With You",
			link: "https://open.spotify.com/track/02wk5BttM0QL38ERjLPQJB?si=76a45d42073a4912"
		},
		resonatedLyrics: [
			"(It feels)",
			"Cool with you (너랑)",
			"Cool with you (Gotta tell me now)",
			"Cool with you (It's just)",
			"Cool with you (Haha)"
		],
	},
	{
		status: "above-average",
		reason: "I spent half of the day sleeping and woke up at around noon. I was thinking of going outside today, but just spent the majority of the day watching stuff on YouTube.",
		spotify: {
			artist: "Flo Rida, Wynter",
			album: "Throwback Slow Jams",
			song: "Sugar",
			link: "https://open.spotify.com/track/1G9KZ2368NaUUmlMlLkbuL?si=d5ca52997f7f453b"
		},
	},
	{
		status: "below-average",
		reason: "I spent most of the day sleeping again. I feel like I'm worrying about a lot of things.",
		spotify: {
			artist: "AJR",
			song: "Way Less Sad",
			link: "https://open.spotify.com/track/6YIivt0G3ZUuNrM62jp9pL?si=70925e0fe4204306",
			album: "OK ORCHESTRA"
		},
		resonatedLyrics: [
			"You're so insane, you're so insane (ah-ah, ah-ah, ah-ah)",
			"Shut up and just enjoy this feelin'",
			"",
			"Don't you love it, don't you love it?",
			"No, I ain't happy yet",
			"But I'm way less sad",
		],
	},
	{
		status: "above-average",
		reason: "I was called an \"expert\" at something, it was flattering. Also, I got invited by Ange for my past company's Family Day event! I'm gonna see my old coworkers again, for the 2nd year in a row.",
		spotify: {
			artist: "aespa",
			album: "Savage - The 1st Mini Album",
			song: "YEPPI YEPPI",
			link: "https://open.spotify.com/track/3UKKwGrpWWamc0XNSKXjmz?si=898a6198fc9c45b1"
		},
	},
	{
		status: "average",
		spotify: {
			artist: "Red Velvet",
			album: "The ReVe Festival 2022 - Feel My Rhythm",
			song: "Feel My Rhythm",
			link: "https://open.spotify.com/track/2oBMZYteeO8DyXV9gDx6Za?si=f39f8922d20649e5"
		},
	},
	{
		status: "bad",
		spotify: {
			artist: "Ava Max",
			album: "Heaven & Hell",
			song: "Kings & Queens",
			link: "https://open.spotify.com/track/7a53HqqArd4b9NF4XAmlbI?si=892c2f0288844835"
		},
	},
	{
		status: "excellent",
		title: "Big Extrovert Energy",
		icon: "person_play",
		reason: "It was a busy day at work but I'm really happy today because I got to finally find that bug I've been having trouble with for the past few days. In the afternoon, I had a small committee call on next month's \"Sportstival\" event and it was pretty fun, I got to talk to other people and really plan ahead. I'm so excited. After work, I played some games with friends from work! Playing Phasmophobia again was super fun. I played in all of the games and my teammates died, but I managed to live through ALL of the games. There was even one game where everyone died and I was the only survivor. I solved it, boom, charisma points for me. Playing with friends 4 or more is really fun and it made me realize my extroversion again. And that made the day great.",
		spotify: {
			artist: "Leanne & Naara",
			album: "Again",
			song: "Again",
			link: "https://open.spotify.com/track/5KTtIkH3i6sF58N3kyWVnS?si=9fb8bd1ab8fa413f"
		},
		resonatedLyrics: [
			"There's a person standing right in front of me",
			"Hears me talking",
			"Feels me breathing",
			"But doesn't know where I am",
			"It's a pity, please forgive me",
			"I've been caught up in this jam",
			"Of unfortunate apathy",
			"",
			"And it's hard when I still wanna choose you everyday",
			"And that's my plan"
		],
	},
	{
		status: "good",
		reason: "It was a fairly-good day. In the afternoon, I got asked by my friends to play Phasmophobia with them. I also ate take-out food and just watched Downton Abbey before sleeping for the night. I posted a lot of stuff on IG and talked with my friends on there, too. In the evening, I woke up to play Phasmophobia again with friends and had so much fun. I was the only survivor in one map but I, sadly, wasn't able to figure out the ghost.",
		spotify: {
			artist: "Taylor Swift",
			album: "Midnights (The Til Dawn Edition)",
			song: "Bejeweled",
			link: "https://open.spotify.com/track/0VpF6RLdCfPIeYRwMu4tZK?si=cd6b758175ba4d43"
		},
	},
	{
		status: "above-average",
		icon: "bed",
		title: "17 Hours of Sleep!",
		reason: "No way I slept for around/more than 17 hours? That's crazy! I guess I underestimated how tired I am. When I woke up, I was invited by my friends for 2 games of Phasmo with another friend from work. It was fun. Then, I finally got to ask another friend to play L4D with me since I found the time. We just had our usual banter and talk. I realize that I've been friends with them for a long time. They know so much about the things I share with them which came as a shock to me, because I just expect people to forget after I tell stories/chika to them. It made me happy that they still remember the dumb things I did and that they treasure the things I tell them. We lost some games in Valorant after but we laughed so hard. On our last match, we had a win and it was good enough to cap the night off.",
		spotify: {
			artist: "sped up 8282",
			album: "Cupid – Twin Ver. (FIFTY FIFTY) – Sped Up Version",
			song: "Cupid – Twin Ver. (FIFTY FIFTY) – Sped Up Version",
			link: "https://open.spotify.com/track/3B228N0GxfUCwPyfNcJxps?si=00fb3ea3ee5d43db"
		},
		resonatedLyrics: [
			"Surrounded by couples all the time",
			"I guess I should take it as a sign",
			"(Oh why, oh why, oh why, oh why?)",
		],
	},
	{
		status: "above-average",
		title: "But It's...",
		reason: "This day was supposed to horrible, just horrible. An awful, awful day. I was supposed to watch Oppenheimer with my friends online but they stood me up last minute. So I tried to go to MOA Seaside to cry things out, but I actually bumped into one of my close friends from the RC! What the fuck? What are the odds? To meet my friend at this time, this place, with no preparation or anything. What the fuck? Okay, I guess I'm third-wheeling with my friends (again). This was so weird, I can't believe it. I was supposed to just watch Oppenheimer with some random person, but then God made a way for me to be with a couple: Monica and JK. I guess the lyric, \"Surrounded by couples all the time\" from yesterday really is applicable. The thing I was worried about earlier really was...",
		spotify: {
			artist: "Bruno Major",
			song: "Nothing",
			link: "https://open.spotify.com/track/1lORkxEMmsCZqhoxcmk3A3?si=549e342c2ed9406b",
			album: "To Let A Good Thing Die"
		}
	},
	{
		status: "above-average",
		reason: "Regardless, today was a good day. I watched Paranormal Activity 1, 2, and 3. I did a good job of trying to keep up with friends today and that's good enough for me.",
		spotify: {
			artist: "LE SSERAFIM",
			album: "Unforgiven",
			song: "Fire in the belly",
			link: "https://open.spotify.com/track/05RlBHEZg1RmL9DnPgv9Qq?si=5f58bb7ea87f4f1c"
		}
	},
];

export default julyMap;
